import RichText from '@/components/utilities/RichText';
import VisibleLoading from '@/components/utilities/VisibleLoading';
import { resolveHeadingTag } from '@/utils/headings';

const H5 = ({ text, h5align, h5HtmlTag: htmlTag }) => {
  let classNameAlign = 'text-left';
  if (h5align === 'center') {
    classNameAlign = 'text-center mx-auto';
  } else if (h5align === 'right') {
    classNameAlign = 'text-right';
  }

  // Vzhled drží heading-5, úroveň si volí editor (bez volby zůstává <h5>).
  const Tag = resolveHeadingTag(htmlTag, 'h5');

  return (
    <VisibleLoading delay={100}>
      {({ ref, className }) => (
        <Tag ref={ref} className={`heading-5 xl:max-w-[820px] ${classNameAlign} ${className || ''}`.trim()}>
          <RichText>{text}</RichText>
        </Tag>
      )}
    </VisibleLoading>
  );
};
export default H5;
